import Observable from '@scripts/components/concerns/Observable';

/**
 * Light Popin component
 */
export default class extends Observable {
  /**
   * @protected
   *
   * @type {?HTMLElement}
   */
  _popin = null;

  constructor() {
    super();

    this._popin = document.querySelector('.icras-popin');
  }

  /**
   * Create the HTML of the popin
   *
   * @return {void}
   */
  _createPopin() {
    this._popin = document.createElement('div');
    this._popin.classList = 'icras-popin';

    // mask
    let mask = document.createElement('div');
    mask.classList = 'icras-popin-mask';
    this._popin.appendChild(mask);

    // wrapper
    let wrapper = document.createElement('div');
    wrapper.classList = 'icras-popin-wrapper';

    // close
    let close = document.createElement('span');
    close.classList = 'icras-popin-close';
    close.innerText = 'x';
    wrapper.appendChild(close);

    // message
    let message = document.createElement('div');
    message.classList = 'icras-popin-message';
    wrapper.appendChild(message);

    this._popin.appendChild(wrapper);

    close.addEventListener('click', () => this.close());
    mask.addEventListener('click', () => this.close());
  }

  /**
   * Initialize HTML and events
   *
   * @return {void}
   */
  init() {
    this._createPopin();
  }

  /**
   * Build the HTML of the message
   *
   * @param {string|array} messages Message list
   *
   * @return {HTMLElement}
   */
  buildMessage(messages) {
    let message = document.createElement('div');

    if (Array.isArray(messages)) {
      if (messages.length === 1) {
        messages = messages[0];
      } else {
        let ul = document.createElement('ul');
        messages.forEach((msg) => {
          let li = document.createElement('li');
          li.innerText = msg;
          ul.appendChild(li);
        });
        message.appendChild(ul);
      }
    }

    if (typeof messages === 'string') {
      message.innerHTML = messages;
    }

    return message;
  }

  /**
   * If the popin is open
   *
   * @return {boolean}
   */
  isOpen() {
    return this._popin && this._popin.classList.contains('open');
  }

  /**
   * Open popin with messsages
   *
   * @param {string|array} messages Message list
   *
   * @return {void}
   */
  open(messages) {
    if (!this._popin) {
      // create popin
      this.init();
    }

    if (this.isOpen()) {
      // force close
      this.close();
    }

    // message container
    let message = this.buildMessage(messages);
    let container = this._popin.querySelector('.icras-popin-message');
    container.innerHTML = '';
    container.appendChild(message);

    // append popin
    document.body.appendChild(this._popin);
    document.body.classList.add('icras-overflow-hidden');

    // open popin
    this._popin.classList.add('open');

    this.notify({ open: true });
  }

  /**
   * Close popin
   *
   * @return {void}
   */
  close() {
    if (this._popin) {
      this._popin.classList.remove('open');
      this._popin.classList.add('close');
      document.body.classList.remove('icras-overflow-hidden');

      // wait for the end of the animation
      setTimeout(() => {
        this._popin.classList.remove('close');
        document.body.removeChild(this._popin);
      }, 500);

      this.notify({ open: false });
    }
  }
}
